import classanames from 'classnames';
import React, { FC } from 'react';

import { SpinnerProps } from './Spinner.types';
import styles from './Spinner.module.css';

const Spinner: FC<SpinnerProps> = (props) => {
    const { size, className } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            className={classanames(styles.spinner, styles[size], className)}
            viewBox="0 0 32 32"
        >
            <path
                fill="url(#a)"
                fillRule="evenodd"
                d="M30 17.336a1.5 1.5 0 0 0 1.5-1.5c0-2.626-.68-5.206-1.976-7.495a15.4 15.4 0 0 0-5.42-5.58 15.64 15.64 0 0 0-15.109-.608 15.45 15.45 0 0 0-5.858 5.124 15.2 15.2 0 0 0-1.232 14.94 15.4 15.4 0 0 0 4.943 5.998 1.5 1.5 0 1 0 1.76-2.43 12.4 12.4 0 0 1-3.98-4.827 12.2 12.2 0 0 1 .99-11.995 12.45 12.45 0 0 1 4.722-4.128 12.64 12.64 0 0 1 12.208.49 12.4 12.4 0 0 1 4.365 4.494 12.2 12.2 0 0 1 1.587 6.017 1.5 1.5 0 0 0 1.5 1.5"
                clipRule="evenodd"
            />
            <path
                fill="url(#b)"
                fillRule="evenodd"
                d="M30 17.336a1.5 1.5 0 0 0 1.5-1.5c0-2.626-.68-5.206-1.976-7.495a15.4 15.4 0 0 0-5.42-5.58 15.64 15.64 0 0 0-15.109-.608 15.45 15.45 0 0 0-5.858 5.124 15.2 15.2 0 0 0-1.232 14.94 15.4 15.4 0 0 0 4.943 5.998 1.5 1.5 0 1 0 1.76-2.43 12.4 12.4 0 0 1-3.98-4.827 12.2 12.2 0 0 1 .99-11.995 12.45 12.45 0 0 1 4.722-4.128 12.64 12.64 0 0 1 12.208.49 12.4 12.4 0 0 1 4.365 4.494 12.2 12.2 0 0 1 1.587 6.017 1.5 1.5 0 0 0 1.5 1.5"
                clipRule="evenodd"
            />
            <defs>
                <linearGradient
                    id="a"
                    x1="13.925"
                    x2="25.077"
                    y1="2.9"
                    y2="3.377"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentColor" stopOpacity="0" />
                    <stop offset=".274" stopColor="currentColor" stopOpacity=".12" />
                    <stop offset="1" stopColor="currentColor" />
                </linearGradient>
                <linearGradient
                    id="b"
                    x1="16.782"
                    x2="8.257"
                    y1="23.093"
                    y2="4.357"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentColor" stopOpacity="0" />
                    <stop offset="1" stopColor="currentColor" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default Spinner;
